
export const getRuleId = ({field, key, value, originalField = null }) => {
  const filterField = originalField || field; // ASN/ISP scenarios
  return filterField === 'TAG' ? `${key}-${value}` : `${filterField}-${value}`;
}
export const findRuleIndex = (rules, rule) => rules.findIndex( r => getRuleId(r) === getRuleId(rule));
